<template>
  <generic-modal
    :title="$t('update membership expire date')"
    ref="generic_modal"
  >
    <div>
      <div class="title is-5 mb-0">{{ member.name }}</div>
      <div class="subtitle is-6">
        {{ $t("membership expire date") }}
        {{ format_date(member.membership_expire_date) }}
      </div>
      <div class="field">
        <label class="label">{{ $t("new expire date") }}</label>
        <generic-calendar
          type="date"
          display_mode="dialog"
          :is_range="false"
          ref="expire_calendar"
          @selected="expire_date_changed"
        />
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  format_date,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "Gym_memberModal",
  components: { GenericModal, GenericCalendar, GenericDropdown },
  data() {
    return {
      member: {},
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.expire_date;
    },
  },
  methods: {
    format_date,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(member) {
      let v = this;
      v.set_initial_state();
      v.member = member;
      v.meta.gym_member_id = member.gym_member_id;
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      post("/gym_member/membership-expiration", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.member = {};
      v.meta = {
        name: "",
        gym_member_id: "",
        expire_date: "",
        settings: {},
      };
      v.error = "";
      v.$refs.expire_calendar.clear();
      // v.uuid = "";
    },
    expire_date_changed(date) {
      let v = this;
      v.meta.expire_date = date;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
